import Vue from 'vue'
import store from '@/store/index'

export const errorMesgMapper = {
  'auth/operation-not-allowed': 'Your username and/or password may be incorrect'
}

export const errorHandler = err => {
  if (store.getters.isProcessing) {
    store.commit('flipProcessing')
  }
  Vue.toasted.error(errorMesgMapper[err.code] || err.message)
}
